import axios from 'axios';
import { API_URL } from './config';
import { getAuthHeaders } from './commonfunctions/useAuthHelpers';

const BASE = `${API_URL}/api/ai-developer`;
const config = () => ({ headers: getAuthHeaders?.() || {} });
export const aiApi = {
  get: async (path) => (await axios.get(`${BASE}/${path}`, config())).data,
  post: async (path, data) => (await axios.post(`${BASE}/${path}`, data, config())).data,
  delete: async (path) => (await axios.delete(`${BASE}/${path}`, config())).data,
};
export const colors = { orange: '#F07828', orange2: '#ed7f35ff', pale: '#FFF0E3', background: '#F2F2F2', blue: '#1976D2' };
export const errorMessage = (error) => error?.response?.data?.error || error?.message || 'Request failed';
export const asArray = (value) => Array.isArray(value) ? value : [];
export const dateText = (value) => value ? String(value).slice(0, 10) : '—';
